import React from "react";
import loginbg from '../assets/images/login-bg.png';
import Login from '../components/customers/Login';
import mobilelayer_2_top from '../assets/images/mobilelayer_2_top.png';

function Home() {

  const backgroundStyle = {
    backgroundImage: `url(${loginbg})`,
  };
  

  return (
    <div className="login-bg" style={backgroundStyle}>
      <img src={mobilelayer_2_top} className="hide login-bg-imgnew" alt="fruit"/>
      <Login />
    </div>
  );
}

export default Home;
